const normalizeReturnTo = (returnTo) => {
    if (typeof returnTo !== 'string') {
        return null
    }

    const trimmedReturnTo = returnTo.trim()

    if (!trimmedReturnTo || !trimmedReturnTo.startsWith('/') || trimmedReturnTo.startsWith('//')) {
        return null
    }

    return trimmedReturnTo
}

export const getReturnToFromSearch = (search = '') => {
    const returnTo = new URLSearchParams(search).get('returnTo')
    return normalizeReturnTo(returnTo)
}

export const buildAuthPath = (basePath, returnTo) => {
    const normalizedReturnTo = normalizeReturnTo(returnTo)

    if (!normalizedReturnTo) {
        return basePath
    }

    const url = new URL(basePath, 'http://localhost')
    url.searchParams.set('returnTo', normalizedReturnTo)

    return `${url.pathname}${url.search}${url.hash}`
}

export const getCurrentRelativeUrl = (location) => {
    const currentPath = `${location?.pathname || '/'}${location?.search || ''}${location?.hash || ''}`
    return normalizeReturnTo(currentPath) || '/'
}

export const getDefaultPostAuthPath = (usertype, t) => {
    switch (usertype) {
        case 'superadmin':
            return `/${t("url.admin.admin")}/${t("url.admin.dashboard")}`
        case 'club':
            return `/${t("url.club.club")}/${t("url.club.lobby")}`
        default:
            return `/${t("url.client.client")}/${t("url.client.dashboard")}`
    }
}

export const getPostAuthPath = (usertype, t, returnTo = null) => {
    const normalizedReturnTo = normalizeReturnTo(returnTo)

    if (usertype === 'client' && normalizedReturnTo) {
        return normalizedReturnTo
    }

    return getDefaultPostAuthPath(usertype, t)
}

export const shouldUseReturnToOnMarketplaceLogin = (location, t) => {
    const pathname = location?.pathname || ''
    const segments = pathname.split('/').filter(Boolean)

    if (segments[0] === t("url.marketplace.checkOut")) {
        return true
    }

    if (segments.length < 4 || segments[0] !== t("url.marketplace.clubs")) {
        return false
    }

    const detailSections = [
        t("url.marketplace.activities"),
        t("url.marketplace.courts"),
        t("url.marketplace.passTypes"),
        t("url.marketplace.matches")
    ]

    return detailSections.includes(segments[2]) && Boolean(segments[3])
}


